/**
 * Ai được GỠ đánh dấu vắng mặt ca cabin, và từ phút thứ mấy được ĐÁNH.
 *
 * Luật cũ: nút chỉ hiện khi ca đã kết thúc. Đo trên 3.087 ca thật, ca dài 130
 * phút (81,2%) hoặc 120 phút (18,8%) — người trực phải nhớ quay lại sau hơn
 * hai tiếng, và kết quả là chỉ 3,4% số ca được đánh vắng.
 *
 * Luật mới: đánh được sau khi ca chạy 30 phút; gỡ thì chỉ admin.
 *
 * Backend gác lại y hệt (`utils/cabin-danh-vang.util`). Ẩn nút là để người
 * dùng khỏi bấm nhầm, không phải hàng rào — ai cũng gọi thẳng API được.
 *
 * Hàm thuần, không đọc localStorage: gọi là truyền `user` vào, để test được.
 */
import { ROLE } from '../constants/roles.constant';

/** Chốt với người vận hành 22/09/2026. */
export const NGUONG_PHUT_DANH_VANG = 30;

/** Hẹp hơn tập được ĐÁNH: gỡ là xoá dấu vết một buổi vắng. */
export const VAI_DUOC_GO_VANG = [ROLE.ADMIN, ROLE.DRIVING.ADMIN];

/**
 * Đã qua mốc được đánh vắng chưa.
 *
 * @param {Date|string|number|null} start giờ bắt đầu ca
 * @param {Date} [bayGio] truyền vào để test không phụ thuộc đồng hồ
 * @param {number} [nguongPhut]
 * @returns {boolean}
 */
export function daDenGioDanhVang(start, bayGio, nguongPhut = NGUONG_PHUT_DANH_VANG) {
  if (!start) return false;
  const batDau = new Date(start);
  if (Number.isNaN(batDau.getTime())) return false;
  const nguong = Number.isFinite(Number(nguongPhut)) && Number(nguongPhut) >= 0
    ? Number(nguongPhut) : NGUONG_PHUT_DANH_VANG;
  const now = bayGio instanceof Date ? bayGio : new Date();
  return now.getTime() >= batDau.getTime() + nguong * 60000;
}

/** @param {{role?: Array<number>}|null|undefined} user */
export function coQuyenGoVang(user) {
  const vai = user && Array.isArray(user.role) ? user.role : [];
  return VAI_DUOC_GO_VANG.some((v) => vai.includes(v));
}

/** Đọc `user-info` trong localStorage rồi trả lời. */
export function coQuyenGoVangHienTai() {
  try {
    return coQuyenGoVang(JSON.parse(localStorage.getItem('user-info')));
  } catch (e) {
    return false;
  }
}
